<template>
  <img
    src="/images/icons/footer-x.svg"
    loading="lazy"
    width="37"
    height="37"
    alt="footer insta icon"
  />
</template>
